import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TiposDeSocioConstant from 'constants/tiposDeSocio'

const TipoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-tipo' md={2} />
      <Col md={10}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-tipo'
            >
              <option value=''>Seleccionar</option>
              {TiposDeSocioConstant.__array.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFormGroup)
